<template lang="pug">
.column.col-12
  form-group(:label="'ordem_servico.endereco' | tModel")
    a.form-input.text-primary.c-hand(@click="active = true")
      span(v-if="endereco", @click="active = true")
        i.fa.fa-edit
        |
        | {{ search }}
      span(v-else, @click="active = true")
        i.fa.fa-edit
        |
        | {{ noAddressText }}
  fieldset(:disabled="loading")
    form(@submit.prevent="onSubmit")
      modal(
        :active="active",
        :showCloseButton="false",
        title="Preencha os dados de endereço"
      )
        div(slot="modal-body")
          form-group(label="Procurar endereço")
            google-places-autocomplete#place-autocomplete(
              ref="placeRef",
              :disabled="false",
              types="",
              :country="['br']",
              @inputChange="onInputChange",
              @placechanged="onPlaceChanged",
              classname="form-input",
              placeholder="Buscar endereço"
            )
          .text-error(v-if="searchError") {{ searchError }}

          .columns(v-if="endereco")
            .column.col-12
              .divider.text-center(data-content="Campos do endereço")
            item-col.mb-2.col-3.col-sm-12(
              label="endereco.cep",
              :value="endereco.cep ? $options.filters.cep(endereco.cep) : 'Não informado'",
              :class="{ 'text-warning text-italic': !endereco.cep }"
            )
            item-col.mb-2.col-4.col-sm-12(
              label="endereco.cidade",
              :value="endereco.cidade ? `${endereco.cidade.nome} - ${endereco.cidade.uf}` : 'Não informado'",
              :class="{ 'text-warning text-italic': !endereco.cidade }"
            )
            item-col.mb-2.col-5.col-sm-12(
              label="endereco.bairro",
              :value="$v.endereco.bairro.nome.$model || 'Não informado'",
              :class="{ 'text-warning text-italic': !$v.endereco.bairro.nome.$model }"
            )
            item-col.mb-2.col-7.col-sm-12(
              label="endereco.logradouro",
              :value="$v.endereco.logradouro.nome.$model || 'Não informado'",
              :class="{ 'text-warning text-italic': !$v.endereco.logradouro.nome.$model }"
            )
            item-col.mb-2.col-4.col-sm-12(
              label="endereco.numero",
              :value="$v.endereco.numero.$model || 'Não informado'"
              :class="{ 'text-warning text-italic': !$v.endereco.numero.$model }"
            )
            .column.col-12
              .divider.text-center(data-content="Informar complemento")
            form-group.column.col-sm-12(
              :label="'endereco.complemento' | tModel",
              :validation="$v.endereco.complemento"
            )
              input.form-input(
                v-model="$v.endereco.complemento.$model",
                :placeholder="'endereco.complemento' | tModel"
              )

        div(slot="modal-footer")
          a.btn.btn-link.text-error(@click="cancel")
            btn-content(name="cancel")
          button.btn.btn-primary(:disabled="$v.endereco.$invalid")
            btn-content(name="save")
</template>

<script>
import ceps from "@/api/ceps"
import { required } from "vuelidate/lib/validators"

export default {
  props: {
    noAddressText: { type: String, required: true },
  },

  data() {
    return {
      active: false,
      endereco: null,
      search: "",
      searchError: "",
      loading: false,
    }
  },
  validations: {
    endereco: {
      bairro: { nome: {} },
      cep: {},
      cidade: { nome: {}, uf: {} },
      logradouro: { nome: {} },
      numero: {},
      complemento: {},
      latitude: { required },
      longitude: { required },
    },
  },
  methods: {
    open(query = "") {
      // window.$ref = this.$refs.placeRef
      this.$refs.placeRef.update(query)
      this.active = true
    },
    onSubmit() {
      this.$emit("selected", this.endereco)
      this.active = false
    },
    cancel() {
      this.active = false
      this.search = ""
      this.searchError = ""
      this.endereco = null
      this.$refs.placeRef.clear()
      this.$emit("selected", null)
    },
    onInputChange({ newVal }) {
      this.search = newVal
    },
    async onPlaceChanged(data, { address_components }) {
      this.searchError = ""
      this.endereco = null
      const {
        street_number,
        postal_code,
        latitude,
        longitude,
        administrative_area_level_2,
        administrative_area_level_1,
        route,
      } = data
      if (postal_code) {
        this.loading = true
        try {
          const res = await ceps.buscaCep((postal_code || "").replace("-", ""))
          this.endereco = {
            ...res,
            numero: street_number,
            complemento: "",
            latitude,
            longitude,
          }
        } catch (error) {
          this.searchError = "Erro ao buscar CEP"
        } finally {
          this.loading = false
        }
      } else {
        const bairro = (address_components || []).find(i =>
          i.types.includes("sublocality"),
        ) || { long_name: "" }

        this.endereco = {
          cep: "",
          complemento: "",
          logradouro: { nome: route },
          cidade: {
            nome: administrative_area_level_2,
            uf: administrative_area_level_1,
          },
          bairro: { nome: bairro.long_name || "" },
          numero: street_number,
          latitude,
          longitude,
        }
      }
    },
  },
}
</script>
